// Approximate lat/lng for places referenced in the dataset.
// Used to plot mentioned places on the article world map.
export type Coord = readonly [number, number];

export const PLACE_COORDS: Record<string, Coord> = {
  // Countries
  Italia: [42.5, 12.5],
  Cina: [35, 105],
  Russia: [60, 100],
  Libia: [27, 17],
  Siria: [35, 38],
  Iran: [32, 53],
  Germania: [51, 10],
  Grecia: [39, 22],
  Turchia: [39, 35],
  Algeria: [28, 2],
  Tunisia: [34, 9],
  Cipro: [35, 33],
  Slovenia: [46, 15],
  Serbia: [44, 21],
  USA: [38, -97],
  "Stati Uniti": [38, -97],
  "Stati Uniti d'America": [38, -97],
  UE: [50, 10],
  Europa: [50, 10],
  Lussemburgo: [49.6, 6.1],
  "Emirati Arabi Uniti": [24, 54],
  Azerbaigian: [40.5, 47.5],
  Francia: [46, 2],
  India: [20, 78],
  "Costa d'Avorio": [7.5, -5.5],
  Vietnam: [16, 108],
  Kenya: [-0.5, 37.5],
  Egitto: [26, 30],
  Qatar: [25, 51],
  Giappone: [36, 138],
  Spagna: [40, -3.5],
  Portogallo: [39.5, -8],
  Bielorussia: [53, 28],
  Kazakhstan: [48, 68],
  Ucraina: [49, 32],
  Malta: [35.9, 14.5],
  Panama: [9, -80],
  Singapore: [1.3, 103.8],
  "Hong Kong": [22.3, 114.2],
  "Arabia Saudita": [24, 45],
  Nigeria: [10, 8],
  Brasile: [-10, -55],
  Marocco: [32, -6],

  // Cities / regions
  Roma: [41.9, 12.5],
  Milano: [45.5, 9.2],
  Torino: [45.1, 7.7],
  Napoli: [40.8, 14.3],
  Genova: [44.4, 8.9],
  Trieste: [45.6, 13.8],
  Mantova: [45.2, 10.8],
  Messina: [38.2, 15.6],
  Catania: [37.5, 15.1],
  Palermo: [38.1, 13.4],
  Bari: [41.1, 16.9],
  "La Spezia": [44.1, 9.8],
  Monfalcone: [45.8, 13.5],
  Muggiano: [44.1, 9.9],
  "Castellammare di Stabia": [40.7, 14.5],
  Mirafiori: [45.0, 7.6],
  Ferrara: [44.8, 11.6],
  Piombino: [42.9, 10.5],
  Panigaglia: [44.1, 9.8],
  Lampedusa: [35.5, 12.6],
  "Gioia Tauro": [38.4, 15.9],
  Rosarno: [38.5, 15.9],
  "Costa Smeralda": [41.1, 9.5],
  "Stretto di Messina": [38.2, 15.6],
  "Canale di Sicilia": [37, 12],
  "Canale di Suez": [30.6, 32.3],
  "Mar Ionio": [38, 19],
  "Mar Libico": [33.5, 22],
  "Mar Rosso": [20, 38],
  "Nord Africa": [28, 10],
  Cefalù: [38, 14],
  "Port Said": [31.3, 32.3],
  Dubai: [25.3, 55.3],
  "Molo VII": [45.6, 13.8],
  Sardegna: [40.1, 9.1],
  "La Maddalena": [41.2, 9.4],
  "Salto di Quirra": [39.6, 9.6],
  Cagliari: [39.2, 9.1],
  Bruxelles: [50.8, 4.4],
  Pechino: [39.9, 116.4],
  Algeri: [36.8, 3.1],
  Cairo: [30.0, 31.2],
  Valencia: [39.5, -0.4],
  Francoforte: [50.1, 8.7],
  Marsiglia: [43.3, 5.4],
  Barcellona: [41.4, 2.2],
  Tolone: [43.1, 5.9],
  Corinto: [37.9, 22.9],
  Galatina: [40.2, 18.2],
  "Nuova Delhi": [28.6, 77.2],
  Novorossijsk: [44.7, 37.8],
  "Ust-Luga": [59.7, 28.4],
  Gibilterra: [36.1, -5.4],
  Ceuta: [35.9, -5.3],
  Primorsk: [60.4, 28.6],
  Antalya: [36.9, 30.7],
  Caucaso: [43, 44],
  "Golfo di Guinea": [3, 3],
  Sahel: [15, 0],
  Africa: [0, 20],
  Santos: [-23.9, -46.3],
  Agrate: [45.6, 9.4],
  Shenzhen: [22.5, 114.1],
  Pavia: [45.2, 9.2],
  Guernsey: [49.4, -2.6],
  Washington: [38.9, -77.0],
  Singapore_: [1.3, 103.8],
  Anagni: [41.7, 13.2],
  Latina: [41.5, 12.9],
  Firenze: [43.8, 11.2],
  Venezia: [45.4, 12.3],
  Langhe: [44.6, 8.0],
  Valpolicella: [45.5, 10.9],
  "Valle d'Itria": [40.8, 17.4],
  Lombardia: [45.5, 9.8],
  Campania: [40.9, 14.4],
  Veneto: [45.5, 11.9],
  Puglia: [41, 16.5],
  Toscana: [43.5, 11],
  Marche: [43.5, 13.3],
  Sicilia: [37.5, 14],
  Vicenza: [45.5, 11.5],
  Modena: [44.6, 10.9],
  Brescia: [45.5, 10.2],
  Bologna: [44.5, 11.3],
  Maranello: [44.5, 10.9],
  Caserta: [41.1, 14.3],
  Vimercate: [45.6, 9.4],
  Malpensa: [45.6, 8.7],
  "Rosignano Solvay": [43.4, 10.4],
  "Porto Marghera": [45.5, 12.2],
  Rovigo: [45.1, 11.8],
  Gargano: [41.8, 16.0],
  Fusaro: [40.8, 14.1],
  Nerviano: [45.5, 8.9],
  Olbia: [40.9, 9.5],
  Reggio_Calabria: [38.1, 15.6],
  "La Spezia_": [44.1, 9.8],
  Friuli: [46.2, 13.2],
  Virgilio: [45.1, 10.8],

  // Additional countries commonly referenced in dispatches
  Oman: [21, 57],
  Bahrein: [26, 50.6],
  Bahrain: [26, 50.6],
  Kuwait: [29.3, 47.7],
  Giordania: [31, 36],
  Libano: [34, 36],
  Israele: [31.5, 35],
  Palestina: [31.9, 35.2],
  Sudan: [15, 30],
  Etiopia: [9, 40],
  Sudafrica: [-30, 25],
  Senegal: [14, -14],
  Mali: [17, -4],
  Ciad: [15, 19],
  Afghanistan: [33, 66],
  Pakistan: [30, 70],
  Bangladesh: [23.7, 90.4],
  "Sri Lanka": [7, 81],
  Thailandia: [15, 101],
  Filippine: [13, 122],
  Indonesia: [-2, 118],
  Malaysia: [4, 102],
  "Corea del Sud": [36.5, 127.5],
  "Corea del Nord": [40, 127],
  Mongolia: [47, 104],
  Kazakistan: [48, 68],
  Uzbekistan: [41, 64],
  Turkmenistan: [38.5, 58],
  Kirghizistan: [41, 75],
  Tagikistan: [39, 71],
  Armenia: [40, 45],
  Georgia: [42, 43.5],
  Polonia: [52, 19],
  Cechia: [49.8, 15.5],
  Slovacchia: [48.7, 19.5],
  Ungheria: [47, 19.5],
  Romania: [46, 25],
  Bulgaria: [42.7, 25.5],
  Moldova: [47, 28.5],
  Albania: [41, 20],
  Macedonia: [41.6, 21.7],
  Kosovo: [42.6, 20.9],
  Montenegro: [42.7, 19.4],
  "Bosnia ed Erzegovina": [43.9, 17.7],
  Croazia: [45.1, 15.2],
  Austria: [47.5, 14.5],
  Svizzera: [46.8, 8.2],
  "Regno Unito": [54, -2],
  Irlanda: [53, -8],
  Belgio: [50.5, 4.5],
  "Paesi Bassi": [52, 5.5],
  Olanda: [52, 5.5],
  Danimarca: [56, 10],
  Svezia: [62, 15],
  Norvegia: [64, 10],
  Finlandia: [64, 26],
  Estonia: [59, 26],
  Lettonia: [57, 25],
  Lituania: [55, 24],
  Canada: [60, -95],
  Messico: [23, -102],
  Argentina: [-35, -65],
  Cile: [-30, -71],
  Colombia: [4, -72],
  Venezuela: [8, -66],
  Cuba: [22, -79],
  Australia: [-25, 133],
  "Nuova Zelanda": [-41, 174],

  // Macro-regions (centroids)
  Asia: [35, 90],
  "Asia Occidentale": [35, 45],
  "Asia Centrale": [40, 65],
  "Asia Meridionale": [22, 80],
  "Asia Orientale": [35, 115],
  "Sud-est asiatico": [5, 110],
  "Africa Subsahariana": [0, 25],
  "Medio Oriente": [30, 45],
  "Golfo Persico": [26, 53],
  Balcani: [43, 20],
  "Europa Meridionale": [42, 15],
  "Europa Centrale": [50, 15],
  "Europa Occidentale": [48, 5],
  "Europa Orientale": [50, 30],
  "Europa Settentrionale": [60, 15],
  "Europa del Nord": [60, 15],
  Mediterraneo: [37, 18],
  "Nord America": [50, -100],
  "Sud America": [-15, -60],
  "America Latina": [0, -60],
  Caraibi: [20, -75],
  Oceania: [-25, 140],
};
